// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"178":"0eb8fd90","358":"1d008189"}[chunkId] + ".css";
};